import { gql } from "apollo-boost";

export const GET_NOTIFICATION_CURRENT_USER = gql`
  query getNotificationCurrentUser{
    getNotificationCurrentUser {
      type name msg qty notificationAt
      fromUser {
        id code nameLocal surnameLocal photo
      }
    }
  }
`;
